import React from 'react';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const CreditCardEntry = createReactClass({
  getInitialState() {
    const paramsUser = this.props.paramsUser || {};
    let cardNumber = '';
    if (paramsUser.cc_number) {
      cardNumber = paramsUser.cc_number;
    }
    // make sure these are strings
    let month = '';
    if (paramsUser.cc_expiration_month) {
      month = paramsUser.cc_expiration_month.toString();
    }
    let year = '';
    if (paramsUser.cc_expiration_year) {
      year = paramsUser.cc_expiration_year.toString();
    }
    let cvv = '';
    if (paramsUser.cc_csc) {
      cvv = paramsUser.cc_csc;
    }
    let zip = '';
    if (paramsUser.zip) {
      zip = paramsUser.zip;
    }
    return {
      ccInputText: cardNumber,
      cvvInputText: cvv,
      zipInputText: zip,
      validCardNumber: false,
      invalidCardNumber: false,
      validCvv: false,
      invalidCvv: false,
      selectedMonth: month,
      selectedYear: year
    };
  },
  componentWillMount() {
    if (typeof recurly != 'undefined' && !recurly.configured) {
      recurly.configure(this.props.recurlyPublicKey);
    }
  },
  componentDidMount() {
    // handle validation checks immediately when provided with card info
    if (this.props.paramsUser && (this.props.paramsUser.cc_number || this.props.paramsUser.cc_csc)) {
      const validCCNumber =
        !this.props.errors.cc_number && this.validateCardNumber(this.state.ccInputText) && this.validateCardType(this.state.ccInputText);
      const validCvv =
        !this.props.errors.cc_csc &&
        this.validateCvv(this.state.cvvInputText) &&
        this.cvvCorrectForCard(this.state.ccInputText, this.state.cvvInputText);

      this.setState({ validCvv, validCardNumber: validCCNumber, invalidCvv: !validCvv, invalidCardNumber: !validCCNumber });
    }
  },
  CARDTYPES: {
    discover: 'discover',
    master: 'master',
    american_express: 'american_express',
    visa: 'visa',
    jcb: 'jcb',
    diners_club: 'diners_club',
    unknown: 'unknown'
  },
  preSubmitErrors() {
    const errors = {};
    if (this.state.ccInputText && this.state.ccInputText.trim() == '') {
      errors.cc_number = [StringConstantsMixin.strings.REQUIRED];
    }
    if (this.state.cvvInputText && this.state.cvvInputText.trim() == '') {
      errors.cc_csc = [StringConstantsMixin.strings.REQUIRED];
    }
    if (this.state.selectedMonth && this.state.selectedMonth.trim() == '') {
      errors.cc_expiration_month = [StringConstantsMixin.strings.REQUIRED];
    }
    if (this.state.selectedYear && this.state.selectedYear.trim() == '') {
      errors.cc_expiration_year = [StringConstantsMixin.strings.REQUIRED];
    }
    return errors;
  },
  validateCardNumber(cardNumber) {
    // card number can include spaces or dashes
    if (typeof recurly != 'undefined') {
      return recurly.validate.cardNumber(cardNumber);
    }
    return true;
  },
  validateExpiry(month, year) {
    // will work with strings or numbers, one or two digit month, two or four digit year
    if (typeof recurly != 'undefined') {
      return recurly.validate.expiry(month, year);
    }
    return true;
  },
  validateCvv(cvv) {
    if (typeof recurly != 'undefined') {
      return recurly.validate.cvv(cvv);
    }
    return true;
  },
  validateCardType(cardNumber) {
    if (typeof recurly != 'undefined') {
      const cardType = recurly.validate.cardType(cardNumber);
      return this.CARDTYPES[cardType];
    }
    return 'american_express';
  },
  cvvCorrectForCard(cardNumber, cvv) {
    const cardType = this.validateCardType(this.state.ccInputText);
    return (cardType == 'american_express' && cvv.length == 4) || (cardType != 'american_express' && cvv.length == 3);
  },
  checkIfRemoveStateErrors() {
    let errorsToRemove = [];
    if (this.state.validCardNumber) {
      errorsToRemove.push('cc_number', 'base');
    }

    if (this.state.validCvv) {
      errorsToRemove.push('cc_csc', 'base');
    }

    // expiration must be validated together
    if (this.validateExpiry(this.state.selectedMonth, this.state.selectedYear))
      errorsToRemove = errorsToRemove.concat(['cc_expiration_month', 'cc_expiration_year', 'base']);

    this.props.clearStateErrors(errorsToRemove);
  },
  handleCcInputTextChange(event) {
    const newVal = event.target.value;
    if (newVal && newVal.length > 0 && this.state.ccInputText != '') {
      this.props.clearStateErrors(['cc_number']);
    }
    if (newVal == '') {
      this.setState({ ccInputText: newVal, validCardNumber: false, invalidCardNumber: false });
    } else if (!newVal.match(/\D/) && newVal.length < 15) {
      this.setState({ ccInputText: newVal });
    } else if (!newVal.match(/\D/) && newVal.length == 15) {
      const cardType = this.validateCardType(this.state.ccInputText);
      if (cardType == 'american_express' || cardType == 'unknown') {
        const valid = this.validateCardNumber(newVal);
        if (valid) {
          this.setState({ ccInputText: newVal, validCardNumber: true }, this.checkIfRemoveStateErrors);
        } else {
          this.setState({ ccInputText: newVal }, this.checkIfRemoveStateErrors);
        }
      } else {
        this.setState({ ccInputText: newVal });
      }
    } else if (!newVal.match(/\D/) && newVal.length == 16) {
      const valid = this.validateCardNumber(newVal);
      if (this.state.cvvInputText.length >= 3) {
        const validCvv = this.cvvCorrectForCard(newVal, this.state.cvvInputText);
        this.setState(
          { ccInputText: newVal, validCardNumber: valid, invalidCardNumber: !valid, validCvv, invalidCvv: !validCvv },
          this.checkIfRemoveStateErrors
        );
      } else {
        this.setState({ ccInputText: newVal, validCardNumber: valid, invalidCardNumber: !valid }, this.checkIfRemoveStateErrors);
      }
    } else if (newVal.length < this.state.ccInputText.length) {
      this.setState({ ccInputText: newVal });
    }
  },
  handleCcInputTextBlur() {
    if (this.state.ccInputText != '') {
      const valid = this.validateCardNumber(this.state.ccInputText);
      this.setState({ validCardNumber: valid, invalidCardNumber: !valid }, this.checkIfRemoveStateErrors);
    }
  },
  handleMonthChange(event) {
    const newVal = event.target.value;
    this.setState({ selectedMonth: newVal }, this.checkIfRemoveStateErrors);
  },
  handleYearChange(event) {
    const newVal = event.target.value;
    this.setState({ selectedYear: newVal }, this.checkIfRemoveStateErrors);
  },
  handleCvvInputTextChange(event) {
    const newVal = event.target.value;
    if (newVal == '') {
      this.setState({ cvvInputText: newVal, validCvv: false, invalidCvv: false });
    } else if (!newVal.match(/\D/)) {
      if (newVal.length < 3) {
        this.setState({ cvvInputText: newVal });
      } else if (newVal.length == 3) {
        if (this.state.ccInputText && this.state.ccInputText.length == 16) {
          const cardType = this.validateCardType(this.state.ccInputText);
          if (cardType == 'american_express') {
            this.setState({ cvvInputText: newVal }, this.checkIfRemoveStateErrors);
          } else {
            this.setState({ cvvInputText: newVal, validCvv: true, invalidCvv: false }, this.checkIfRemoveStateErrors);
          }
        } else {
          this.setState({ cvvInputText: newVal });
        }
      } else if (newVal.length == 4) {
        if (this.state.ccInputText && (this.state.ccInputText.length == 16 || this.state.ccInputText.length == 15)) {
          const cardType = this.validateCardType(this.state.ccInputText);
          if (cardType == 'american_express' || cardType == 'unknown') {
            this.setState({ cvvInputText: newVal, validCvv: true, invalidCvv: false }, this.checkIfRemoveStateErrors);
          } else {
            this.setState({ validCvv: true, invalidCvv: false }, this.checkIfRemoveStateErrors);
          }
        } else {
          this.setState({ cvvInputText: newVal });
        }
      } else if (newVal.length < this.state.cvvInputText.length) {
        this.setState({ cvvInputText: newVal });
      }
    }
  },
  handleCvvInputTextBlur() {
    if (this.state.cvvInputText != '') {
      const valid = this.validateCvv(this.state.cvvInputText);
      this.setState({ validCvv: valid, invalidCvv: !valid }, this.checkIfRemoveStateErrors);
    }
  },
  handleZipTextChange(event) {
    const newVal = event.target.value;
    if (newVal.length > 10) return;
    this.setState({ zipInputText: newVal });
  },
  cardNumberDiv() {
    let holderClasses = 'holder';
    const ccInputText = this.state.ccInputText;
    let ccInputTextClasses = 'string required text';
    let ccValidSpan = '';
    let errorMessage = '';
    let divClasses = 'input string required';
    if (Object(this.props.errors).hasOwnProperty('cc_number')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.props.errors.cc_number[0]}</span>;
    }
    if (this.state.validCardNumber) {
      ccValidSpan = <span className="valid" />;
      ccInputTextClasses += ' valid';
    } else if (this.state.invalidCardNumber) {
      divClasses += ' field_with_errors';
      ccValidSpan = <span className="invalid" title={StringConstantsMixin.strings.PRO.CC_NUM_ERROR} />;
      ccInputTextClasses += ' invalid';
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <input
            id="user_cc_number"
            name="user[cc_number]"
            className={ccInputTextClasses}
            type="text"
            placeholder={StringConstantsMixin.strings.PRO.CARD_NUMBER}
            value={ccInputText}
            onChange={this.handleCcInputTextChange}
            onBlur={this.handleCcInputTextBlur}
          />
          {ccValidSpan}
          {errorMessage}
        </div>
      </div>
    );
  },
  monthDiv() {
    let holderClasses = 'holder';
    const selectedMonth = this.state.selectedMonth;
    const monthOptions = [];
    let errorMessage = '';
    let divClasses = 'select required flat-select';
    let selectClasses = 'select required flat-select';
    if (selectedMonth == null || selectedMonth == '') {
      monthOptions.push(
        <option key="0" value="">
          {StringConstantsMixin.strings.PRO.MONTH}
        </option>
      );
      selectClasses += ' default-select-color';
    }
    for (let month = 1; month <= 12; month++) {
      monthOptions.push(
        <option value={month} key={month}>
          {month}
        </option>
      );
    }
    if (Object(this.props.errors).hasOwnProperty('cc_expiration_month')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.props.errors.cc_expiration_month[0]}</span>;
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <select
            value={selectedMonth}
            className={selectClasses}
            id="user_cc_expiration_month"
            name="user[cc_expiration_month]"
            onChange={this.handleMonthChange}
          >
            {monthOptions}
          </select>
          {errorMessage}
        </div>
      </div>
    );
  },
  yearDiv() {
    let holderClasses = 'holder';
    const selectedYear = this.state.selectedYear;
    const yearOptions = [];
    let errorMessage = '';
    let divClasses = 'select required flat-select';
    let selectClasses = 'select required flat-select';

    if (Object(this.props.errors).hasOwnProperty('cc_expiration_year')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.props.errors.cc_expiration_year[0]}</span>;
    }
    if (selectedYear == null || selectedYear == '') {
      yearOptions.push(
        <option key="0" value="">
          {StringConstantsMixin.strings.PRO.YEAR}
        </option>
      );
      selectClasses += ' default-select-color';
    }
    for (let x = 0; x <= 20; x++) {
      const year = new Date().getFullYear() + x;
      yearOptions.push(
        <option value={year} key={year}>
          {year}
        </option>
      );
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <select
            value={selectedYear}
            className={selectClasses}
            id="user_cc_expiration_year"
            name="user[cc_expiration_year]"
            onChange={this.handleYearChange}
          >
            {yearOptions}
          </select>
          {errorMessage}
        </div>
      </div>
    );
  },
  cvvDiv() {
    let holderClasses = 'holder';
    const cvvInputText = this.state.cvvInputText;
    let cvvInputTextClasses = 'string required text';
    let cvvValidSpan = '';
    let errorMessage = '';
    let divClasses = 'input string required';
    if (Object(this.props.errors).hasOwnProperty('cc_csc')) {
      divClasses += ' field_with_errors';
      holderClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.props.errors.cc_csc[0]}</span>;
    }
    if (this.state.validCvv) {
      cvvValidSpan = <span className="valid" />;
      cvvInputTextClasses += ' valid';
    } else if (this.state.invalidCvv) {
      divClasses += ' field_with_errors';
      cvvValidSpan = <span className="invalid" title={StringConstantsMixin.strings.PRO.CVV_ERROR} />;
      cvvInputTextClasses += ' invalid';
    }
    return (
      <div className={holderClasses}>
        <div className={divClasses}>
          <input
            className={cvvInputTextClasses}
            id="user_cc_csc"
            name="user[cc_csc]"
            placeholder={StringConstantsMixin.strings.PRO.CVV}
            type="text"
            value={cvvInputText}
            onChange={this.handleCvvInputTextChange}
            onBlur={this.handleCvvInputTextBlur}
          />
          {cvvValidSpan}
          {errorMessage}
        </div>
      </div>
    );
  },
  zipDiv() {
    const divClasses = 'input string required';
    return (
      <div className="holder">
        <div className={divClasses}>
          <input
            className="string text"
            id="user_zip"
            name="user[zip]"
            placeholder={StringConstantsMixin.strings.PRO.ZIPCODE}
            type="text"
            value={this.state.zipInputText}
            onChange={this.handleZipTextChange}
            onBlur={this.handleZipTextBlur}
          />
        </div>
      </div>
    );
  },
  render() {
    const cardNumberDiv = this.cardNumberDiv();
    const cvvDiv = this.cvvDiv();
    const monthDiv = this.monthDiv();
    const yearDiv = this.yearDiv();
    const zipDiv = this.zipDiv();

    return (
      <div>
        {cardNumberDiv}
        <div className="expiration-holder clearfix">
          {monthDiv}
          {yearDiv}
        </div>
        <div className="cvv-zip-holder clearfix">
          {cvvDiv}
          {zipDiv}
        </div>
      </div>
    );
  }
});

CreditCardEntry.defaultProps = {
  errors: {}
};

export { CreditCardEntry };
